import styled from 'styled-components/macro';

import FlexContainer from 'components/FlexContainer/FlexContainer';

export const getPopupContentStyle = (isMobile: boolean): Record<string, string> => ({
  width: '100%',
  height: isMobile ? '100%' : 'auto',
  maxWidth: isMobile ? 'none' : '400px',
  padding: isMobile ? '1rem 1rem 1rem' : '0.875rem 1rem 0.875rem',
});

export const FormStyled = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 0.625rem;
`;

export const FlexContainerControlsStyled = styled(FlexContainer)`
  margin-top: 1rem;
`;
